import { actions } from './category_form_template/actions'
import { getters } from './category_form_template/getters'
import { state } from './category_form_template/state'
import { mutations } from './category_form_template/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
